import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import VinWonderPrice from '../models/VinWonderPrice';
import Urls from './../api/Urls';

export function getVinWonderPrice(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_PRICE_LIST,
        params: params,
        parser: VinWonderPricesDataParser,
    }).get();
}

export function getVinWonderPriceDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_PRICE_DETAIL,
        endpointParams: { id },
        parser: (data) => new VinWonderPrice(data.data),
    }).get();
}

export function createVinWonderPriceDetail(vinWonderPrice) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_PRICE_CREATE,
        parser: (data) => new VinWonderPrice(data.vinWonderPrice),
    }).post(vinWonderPrice.export());
}

export function updateVinWonderPriceDetail(vinWonderPrice) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_PRICE_UPDATE,
        parser: (data) => new VinWonderPrice(data.vinWonderPrice),
    }).put(vinWonderPrice.export());
}

export function deleteVinWonderPriceDetail(vinWonderPrice) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VIN_WONDER_PRICE_DELETE,
        endpointParams: { id: vinWonderPrice.id }
    }).delete();
}


const VinWonderPricesDataParser = (data) => ({
    result: (data.data.result || []).map(item => new VinWonderPrice(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})